import React from "react";
import { toast } from "sonner";
import { Landmark, Copy } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";

const eur = (n) => "€ " + Number(n || 0).toFixed(2).replace(".", ",");
const PLAN = { pro: "Pro", founder: "Fondatore" };
const CYCLE = { monthly: "Mensile", annual: "Annuale", lifetime: "A vita" };

function Row({ label, value, mono, testid }) {
  const copy = () => navigator.clipboard?.writeText(value).then(() => toast.success(`${label} copiato`)).catch(() => {});
  return (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <span className="text-slate-500 text-sm shrink-0">{label}</span>
      <span className="flex items-center gap-1.5 min-w-0">
        <span data-testid={testid} className={`font-semibold text-slate-900 text-sm text-right break-all ${mono ? "font-mono" : ""}`}>{value || "—"}</span>
        {value && <button type="button" onClick={copy} className="text-slate-400 hover:text-primary" aria-label={`Copia ${label}`}><Copy style={{ width: 14, height: 14 }} /></button>}
      </span>
    </div>
  );
}

export default function PendingTransferCard({ transfer, onChanged }) {
  if (!transfer) return null;
  const cancel = async () => {
    if (!window.confirm("Annullare la richiesta di pagamento con bonifico?")) return;
    await api.delete("/billing/bank-transfer");
    toast.success("Richiesta annullata");
    onChanged();
  };
  return (
    <div data-testid="pending-transfer-card" className="mb-6 rounded-xl border border-amber-200 bg-amber-50/60 p-5">
      <div className="flex items-center gap-2">
        <Landmark style={{ width: 18, height: 18 }} className="text-amber-600" />
        <p className="font-bold text-slate-900">Bonifico in attesa di accredito · Piano {PLAN[transfer.plan]} {CYCLE[transfer.cycle]}</p>
      </div>
      <p className="text-sm text-amber-800 mt-1">Il piano sarà attivato solo quando riceveremo l'accredito (di solito 1-2 giorni lavorativi). Indica esattamente questa causale.</p>
      <div className="mt-3 rounded-lg bg-card border border-amber-100 px-4 py-2 divide-y divide-slate-100">
        <Row label="Importo" value={eur(transfer.amount)} mono testid="pending-transfer-amount" />
        <Row label="Intestatario" value={transfer.bank?.holder} testid="pending-transfer-holder" />
        <Row label="IBAN" value={transfer.bank?.iban} mono testid="pending-transfer-iban" />
        {transfer.bank?.bic && <Row label="BIC/SWIFT" value={transfer.bank.bic} mono testid="pending-transfer-bic" />}
        <Row label="Causale" value={transfer.causale} testid="pending-transfer-causale" />
      </div>
      <Button variant="ghost" size="sm" data-testid="pending-transfer-cancel" onClick={cancel} className="mt-3 text-slate-500">Annulla richiesta</Button>
    </div>
  );
}
